import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from './../../../../../services/API/auth/auth.service';

@Component({
    selector: 'app-contenedores-mtn',
    templateUrl: './contenedores-mtn.component.html',
    styleUrls: ['./contenedores-mtn.component.css'],
    standalone: false
})
export class ContenedoresMtnComponent implements OnInit {

  constructor(private authService: AuthService, private router: Router) { }

  ngOnInit(): void {
    if (!this.authService.canViewMantenimientos()) {
      this.router.navigate(['/dashboard/contenedores']);
    }
  }

}
